import { Button } from "react-migration/components/DeprecatedButton";
import { DeprecatedModal as Modal } from "react-migration/components/DeprecatedModal";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import logSiteCardEvent from "react-migration/lib/util/logSiteCardEvent";

type DNCModalProps = {
  onCancelClicked: () => void;
  onAcceptClicked: () => void;
};

export const DNCModal = ({ onCancelClicked, onAcceptClicked }: DNCModalProps) => {
  const { t } = useTranslation();

  const onCancelButtonClicked = () => {
    logSiteCardEvent({ name: "Skip Trace - DNC Registry Cancel Clicked" });
    onCancelClicked();
  };

  const onAcceptButtonClicked = () => {
    logSiteCardEvent({ name: "Skip Trace - DNC Registry Accept Clicked" });
    onAcceptClicked();
  };

  return (
    <Modal contentClasses="bg-background-surface min-w-[590px]! rounded-lg">
      <div className="flex flex-col gap-y-4">
        <span className="font-semibold text-lg text-neutral-950">{t("sites.skip_tracing.dnc")}</span>
        <span className="text-sm leading-5 text-neutral-950">{t("sites.skip_tracing.dnc_description")}</span>
        <div className="flex justify-end align-bottom gap-x-3">
          <Button.Secondary onClick={onCancelButtonClicked}>{t("sites.skip_tracing.cancel")}</Button.Secondary>
          <Button.Primary onClick={onAcceptButtonClicked}>{t("sites.skip_tracing.accept")}</Button.Primary>
        </div>
      </div>
    </Modal>
  );
};
